<template>
    <div class="m-auto px-8 md:px-20 pb-8">
        <h1 class="py-5 text-2xl font-bold">
            <template v-if="bid">Dettaglio</template>
            <template v-else>Crea</template>
            previsionale commerciale per {{ business_unit?.nome }}
        </h1>

        <div v-show="response_message.length" :class="[esito ? 'bg-next-bri' : 'bg-next-orange']"
             class="text-white p-3 mb-3 flex justify-between items-center">
            {{ response_message }}
            <i class="icon-x cursor-pointer" @click="response_message = ''"></i>
        </div>

        <div class="pt-5 grid grid-cols-3 gap-3">
            <div class="flex flex-col col-span-3">
                <Field field_name="Cliente"
                       :errors="getErrors('cliente_id')"
                       placeholder="Cliente">
                    <VueMultiselect @search-change="clienteAutocomplete.search"
                                    :loading="clienteAutocomplete.isLoading"
                                    :options="clienteAutocomplete.options"
                                    v-model="clienteAutocomplete.selection"
                                    track-by="id" label="denominazione"
                                    class="next-vue-multiselect-single"
                                    placeholder="Cliente"
                                    deselectLabel="Deseleziona"
                                    selectedLabel="Selezionato"
                                    selectLabel="Seleziona">
                        <template v-slot:noResult>Nessun elemento trovato.</template>
                        <template v-slot:singleLabel="{option}">
                            {{ `${option.denominazione} - ${option.ragione_sociale}` }}
                        </template>
                        <template v-slot:option="{option}">{{
                                `${option.denominazione} - ${option.ragione_sociale}`
                            }}
                        </template>
                    </VueMultiselect>
                </Field>
            </div>

            <div class="flex flex-col mb-3">
                <Field field_name="Anno" v-model="model.anno" type="number" :inputAttrs="{step:'1'}"
                       :errors="getErrors('anno')">
                </Field>
            </div>
            <div class="flex flex-col mb-3">
                <Field field_name="Fatt. Previsionale" v-model="model.previsto" type="number" :inputAttrs="{step:'0.01'}"
                       :errors="getErrors('previsto')">
                </Field>
            </div>
            <div class="flex flex-col mb-3">
                <Field field_name="Fatt. Progressivo" v-model="model.progresso" type="number" :inputAttrs="{step:'0.01'}"
                       :errors="getErrors('progresso')">
                </Field>
            </div>
        </div>

        <div class="flex pt-3 justify-end">
            <NextButton class="px-3 py-2" @click="save">Salva</NextButton>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Topbar from "@/components/Topbar.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import ModalFigli from "@/components/ModalFigli.vue";
import NextEditor from "@/components/NextEditor.vue";
import Loading from "@/components/Loading.vue";
import Alert from '@/components/Alert.vue';
import MultiselectOption from "@/components/MultiselectOption.vue";
import Field from "@/components/Field.vue";
import NextButton from "@/components/NextButton.vue";
import Autocomplete from "@/setup/Autocomplete";
import bilanciPrevisionaliManager from "@/api/BilanciPrevisionaliManager";
import clientiManager from "@/api/Clienti";
import businessUnitsManager from "@/api/BusinessUnits";
import {Watch} from "vue-property-decorator/lib/decorators/Watch";

@Options({
    name: 'DettaglioBilancioPrevisionale',
    components: {
        MultiselectOption,
        NextButton,
        Loading,
        Field,
        Alert
    },

    props: {
        id: {
            type: [String, Number],
            required: true
        },
        bid: {
            type: [String, Number],
            required: false
        },
    }
})
export default class DettaglioBilancioPrevisionale extends Vue {
    clienteAutocomplete: any = setup(() => Autocomplete(clientiManager))
    model = {anno: '', previsto: 0, progresso: 0, cliente_id:null}
    id!: number
    bid!: number
    errors = {}
    esito = false
    response_message = ''
    business_unit = {}

    created() {
        businessUnitsManager.businessUnit(this.id).then((res:any) => {
            this.business_unit = res.data
        })

        this.fetchRuoloProfessionale()

        this.clienteAutocomplete.search('',0)

    }

    getErrors(field: string) {
        return (this.errors as any)[field]
    }

    fetchRuoloProfessionale() {
        if (this.bid) {
            businessUnitsManager.getBilancioPrevisionale(this.id, this.bid).then((response) => {
                this.model = response.data
            }).then(() => {
                this.clienteAutocomplete.retrieve(this.model.cliente_id)
            })
        }
    }

    @Watch('clienteAutocomplete.selection')
    changeCliente() {
        this.model.cliente_id = this.clienteAutocomplete.selection.id
    }

    save() {
        if (this.bid) {
            businessUnitsManager.updateBilancioPrevisionale(this.id, this.bid, this.model).then(() => {
                this.esito = true
                this.errors = {}
                this.response_message = 'Salvataggio avvenuto corretamente'
            }).catch((res) => {
                this.esito = false
                this.response_message = 'Salvataggio fallito'
                if (res.response.status == 422) {
                    this.errors = res.response.data.errors
                }
            })
        } else {
            businessUnitsManager.createBilancioPrevisionale(this.id, this.model).then((res: any) => {
                this.esito = true
                this.errors = {}
                this.response_message = 'Salvataggio avvenuto corretamente'
                //@ts-ignore
                this.$router.replace({name: 'DettaglioBilancioPrevisionale', params: {id: this.id, bid: res.data.id}})
            }).catch((res) => {
                this.esito = false
                this.response_message = 'Salvataggio fallito'
                if (res.response.status == 422) {
                    this.errors = res.response.data.errors
                }
            })
        }
    }
}
</script>


<style lang="scss">

</style>
